import { hasBuyRequirements } from "../../loyalty/offerShape";
import {
  LoyaltyApplicationLevel,
  LoyaltyOfferType,
  LoyaltyTargetType,
} from "../../loyaltyTypes";
import { LoyaltyCartOffer } from "../LoyaltyCartOffer";
import { LoyaltyItemOffer } from "../LoyaltyItemOffer";
import LoyaltyOffer from "../LoyaltyOffer";

export const createLoyaltyOffer = (offer: LoyaltyOfferType): LoyaltyOffer => {
  return createLoyaltyOfferByCategory(offer);
};

/** @deprecated Use {@link createLoyaltyOffer} — item-level offers are already LoyaltyItemOffer. */
export const createLoyaltyItemOffer = (
  offer: LoyaltyOfferType
): LoyaltyItemOffer => {
  return new LoyaltyItemOffer(offer);
};

/**
 * A buy side made of items, whatever the reward is.
 *
 * A BOGO paying out on the cart is still assembled from items, so it needs the
 * item-offer behaviour — target configs, availability, the offer page — even
 * though its `applicationLevel` is CART. `LoyaltyCartOffer` only adds
 * category predicates a BOGO never matches anyway.
 */
const isItemBuilt = (offer: LoyaltyOfferType): boolean =>
  hasBuyRequirements(offer) &&
  offer.validity?.requirements?.targetType === LoyaltyTargetType.ITEMS;

const createLoyaltyOfferByCategory = (
  offer: LoyaltyOfferType
): LoyaltyOffer => {
  if (offer.applicationLevel === LoyaltyApplicationLevel.ITEM) {
    return new LoyaltyItemOffer(offer);
  }

  return isItemBuilt(offer)
    ? new LoyaltyItemOffer(offer)
    : new LoyaltyCartOffer(offer);
};
